export const steps = [
    {
      id: 0,
      title: "Complete Profile",
      button: "Complete",
    },
    {
      id: 1,
      title: "Step 2: Another Step",
      button: "Pay",
    },
    {
      id: 2,
      title: "Step 3: Yet Another Step",
      button: "Pay",
    },
    {
      id: 3,
      title: "Step 4: More Steps",
      button: "Pay",
    },
    {
      id: 4,
      title: "Step 5: Final Step",
      button: "Complete",
    },
  ];
  
  export const info = [
    {
      id: 0,
      title: "Overview",
      info: "Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love! Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love! Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love.",
    },
    {
      id: 1,
      title: "Why?",
      info: "Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love!Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love!Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love.",
    },
    {
      id: 2,
      title: "What?",
      info: "Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love!Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love!Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love.",
    },
    {
      id: 3,
      title: "Overview",
      info: "Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love! Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love! Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love.",
    },
    {
      id: 4,
      type: "map",
      title: "Overview",
      info: "Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love! Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love! Our AI feature simplifies your life by automating routine tasks. Spend more time on the things you love.",
    },
  ];
  